  const models = [
  {
    image: require("assets/images/dfsk/glory_500.png"),
    title: "GLORY 500",
    link: "Glory_500",
  },
  {
    image: require("assets/images/dfsk/glory_580.png"),
    title: "GLORY 580",
    link: "Glory_580",
  },
  {
    image: require("assets/images/dfsk/ec31.png"),
    title: "eC31",
    link: "eC31",
  },
  {
    image: require("assets/images/dfsk/ec35.png"),
    title: "eC35",
    link: "eC35",
  },
  {
    image: require("assets/images/dfsk/c31.png"),
    title: "C31",
    link: "C31",
  },
  {
    image: require("assets/images/dfsk/c32.png"),
    title: "C32",
    link: "C32",
  },
  {
    image: require("assets/images/dfsk/k01h.png"),
    title: "K01H",
    link: "K01h",
  },
];

export default models;
